export default __webpack_public_path__ + "static/media/unknown_cover.671b5d6c.svg";